module.exports = __webpack_public_path__ + "img/bio_a.52f128da.png";